<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">2021-03-27</p>
    <div class="content">
      <!-- 第一段内容：会议召开 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[0] || ''"></p>
        </div>
      </div>

      <!-- 第二段内容：专家介绍 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[1] || ''"></p>
        </div>
      </div>

      <!-- 图片1：专家组听取汇报 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture1?.url" :alt="currentNews.other?.picture1?.caption">
          <p class="image-caption">{{ currentNews.other?.picture1?.caption }}</p>
        </div>
      </div>

      <!-- 第三段内容：项目介绍与技术突破 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[2] || ''"></p>
        </div>
      </div>

      <!-- 图片2：专家组听取汇报 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture2?.url" :alt="currentNews.other?.picture2?.caption">
          <p class="image-caption">{{ currentNews.other?.picture2?.caption }}</p>
        </div>
      </div>

      <!-- 图片3：赵跃、朱佳敏介绍情况 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture3?.url" :alt="currentNews.other?.picture3?.caption">
          <p class="image-caption">{{ currentNews.other?.picture3?.caption }}</p>
        </div>
      </div>

      <!-- 第四段内容：鉴定委员会意见 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[3] || ''"></p>
        </div>
      </div>

      <!-- 第五段内容：参会人员 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[4] || ''"></p>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

// 获取新闻数据的方法
const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  // 通过ID查找新闻
  const newsItem = newsList.find((news: any) => news.id === 'kejiqianding');
  return newsItem || {};
});

</script>

<style scoped lang="scss">
.page-container {
  overflow: auto;
}

.content-section {
  margin-bottom: 20px;
}

.text-block p {
  text-indent: 2em; /* First line indent */
  line-height: 1.8; /* Line height */
  margin-bottom: 1em; /* Paragraph spacing */
}

.image-section {
  text-align: center;
}

.image-container {
  display: inline-block;
  margin: 10px 0;
}

.image-container img {
  max-width: 80%; /* Adjust width as needed */
  height: auto; /* Maintain aspect ratio */
  border-radius: 4px;
}

.image-caption {
  margin-top: 8px;
  font-size: 14px;
  color: #666;
}

// Highlight style (if needed in the future)
:deep(.highlight) {
  color: #e58a00; /* Example highlight color */
  font-weight: bold;
}
</style> 